export const ONBOARDING_STEP_STORAGE_KEY = (firebaseUid: string) => `onboarding_current_step:${firebaseUid}`;
